import CrudRepository from './CrudRepository'
export default class SocialLinksRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/socialLink/get')
  }
}
